<script>
import { vendorService, promoCodeService, orderService } from "../../services";
import config from "../../config";
import CustomerEditTab from './order_tabs/customer-edit-tab';
import { FormWizard, TabContent } from "vue-form-wizard";
import Multiselect from "vue-multiselect";
import {get_currency, get_decimal} from "../../Helper/helper";
import "vue2-datepicker/index.css";
import DatePicker from "vue2-datepicker";
import moment from "moment";
import { required , requiredIf, email} from "vuelidate/lib/validators";
import { error_message, success_message } from "../../Helper/helper";
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";

export default {
    components: {Layout, PageHeader, DatePicker, Multiselect, vendorService, promoCodeService, orderService, VueFormWizard: FormWizard, TabContent, CustomerEditTab, moment},
    data() {
        return {
            decimal: get_decimal(),
            isLoading: false,
            loading: false,
            disabled: false,
            config: config,
            selectedProduct: "",
            products:[],
            items:[],
            variants:[],
            sub_product:[],
            order_data:[],
            cart: [],
            time_slot: [],
            delivery_charge:0,
            customer_data:[],
            shipping_add_data:[],
            billing_add_data:[],
            product_id:"",
            qty:1,
            item_price:"",
            vat_price:"",
            net_value:0,
            vat_total:0,
            vat_percentage:0,
            item_total:0,
            refund_amount:0,
            refund_price:0,
            refund_total:0,
            sub_total:0,
            sub_total_1: 0,
            sub_total_2: 0,
            credit_amount:0,
            total_credit:0,
            total_amount:0,
            subscription_discount:0,
            subscription_discount_amount:0,
            original_amount:0,
            discount_amount:0,
            vaild_product: [],
            vaild_coupon: "",
            selected_item: null,
            selected_date: "",
            customer_first_name: "",
            customer_last_name: "",
            customer_phone: "",
            customer_address: "",
            customer_email: "",
            customer_bill_address: "",
            currency: get_currency(),
            type:"1",
            order_amount:0,
            timeslot:[],
            selected_timeslot:"",
            cust_type:"",
            order_item:[],
            orderData:'',
            collection_discount_amount:0,
            collection_discount: 0,
            collection_applicable_amount: 0,
            delivery_date:"",
            is_enable:0,
            sub_product_id:"",
            is_elevator:0,
            type_form:{
                selectedProduct:"",
                schedule_date:"",
                order_type:"",
            },
            promo_loading: false,
            promoApplied: false,
            promocode: "",
            appliedCoupon : "",
            item_vat_total : 0,
            newly_added_products : [],
            product_data : [],
        };
    },
    validations: {
        type_form:{
            schedule_date: {
                required : requiredIf(function(form){
                    return this.order_type == '1';
                }),
            },
        }
    },
    methods:{
        validateStep(name) {
            var refToValidate = this.$refs[name];
            return refToValidate.validate();
        },
        asyncProduct(query) {
            this.isLoading = true;
            if(this.$refs.customerEditTab.customer_data.user_role == '1'){
                this.customer_first_name = this.$refs.customerEditTab.customer_data.user_name;
                this.customer_last_name = this.$refs.customerEditTab.customer_data.last_name;
                this.customer_phone = this.$refs.customerEditTab.customer_data.mobile_number;
                this.customer_email = this.$refs.customerEditTab.customer_data.email;
                this.customer_address = this.$refs.customerEditTab.customer_data.address;
                
            }else{
                this.customer_first_name = this.$refs.customerEditTab.customer_data.business_user_name;
                this.customer_last_name = this.$refs.customerEditTab.customer_data.business_last_name;
                this.customer_phone = this.$refs.customerEditTab.customer_data.business_mobile_number;
                this.customer_email = this.$refs.customerEditTab.customer_data.business_email;
                this.customer_address = this.$refs.customerEditTab.customer_data.address;
            }
            if(this.$refs.customerEditTab.customer_data.is_billing_address == 0){
                this.customer_bill_address = this.$refs.customerEditTab.customer_data.bill_address;
            }
            promoCodeService
                .getProductSearch({ search: query })
                .then((response) => {
                this.products = response.data.result.sort((a, b) => {
                    return a.item_name.localeCompare(b.item_name);
                });
                this.isLoading = false;
            });
        },
        clearAllProduct() {
            this.selectedProduct = [];
        },
        productSelected(value) {
            this.product_id = value.id;
            orderService.getVariantByProduct({
                customer_id: this.$refs.customerEditTab.customer_data.user_id,
                product_id: this.product_id, 
                customer_type: this.$refs.customerEditTab.customer_data.user_role
                }).then((response) => {
                this.items = response.data.result;
            });
        },
        addVariant(item){
            var exists = this.variants.some(function(field) {
                return field.id === item.id;
            });
            if (!exists) {
                this.is_enable = 1;
                var price = (item.min_qty <= 1)?item.price:item.mrp;
                this.selected_item = {
                    ...item,
                    qty: 1,
                    item_price: price,
                    item_name:this.type_form.selectedProduct.item_name,
                    // vat_price: Number((Number(item.price * 100 ) / (100 + Number(item .vat))) * Number(item.vat)) / 100,
                    // vat_percentage: Number((Number(item.price * 100 ) / (100 + Number(item .vat))) * Number(item.vat)) / 100,
                    // refund_price: Number(item.refund_price),
                    // refund_amount: Number(item.refund_price),
                    is_new: 1,
                };
            
                this.variants.push(this.selected_item);
                this.itemTotal(this.variants);

            }
        },
        // getOrderItem(){
        //     orderService.getOrderItem({order_id : this.$route.params.order_id}).then((response) => {
        //         if (response.data.code === 200) {
        //             this.order_item = response.data.result.order_item;
        //             this.sub_product = response.data.result.sub_product;
        //             this.order_data = response.data.result.order;
        //             this.type_form.order_type = response.data.result.order.delivery_type;
        //             this.type_form.schedule_date = response.data.result.order.delivery_date;
        //             this.delivery_date = response.data.result.order.delivery_date;
        //             this.timeslot = response.data.result.order.delivery_from_time+'-'+response.data.result.order.delivery_to_time;
        //             this.sub_total_2 =  this.$refs.customerEditTab.typeform.sub_total_2;
                
        //             this.sub_product.forEach(item => {
        //                 var exists = this.variants.some(function(field) {
        //                     return field.id === item.id
        //                 });
        //                 if (!exists) {
        //                     var price = item.price;
        //                     var vatCal = (Number(price * Number(item.vat) / 100));
        //                     this.selected_item = {
        //                         ...item,
        //                         qty: item.item_quantity,
        //                         item_price: item.item_quantity * price,
        //                         // vat_price: item.item_quantity * (Number((Number(price * 100 ) / (100 + Number(item .vat))) * Number(item.vat)) / 100),
        //                         // vat_percentage: Number((Number(price * 100 ) / (100 + Number(item .vat))) * Number(item.vat)) / 100,
        //                         // refund_price: item.item_quantity * Number(item.refund_price),
        //                         // refund_amount: Number(item.refund_price),
        //                         selected_quantity:item.item_quantity,
        //                         is_new: 0,
        //                     };
        //                     this.sub_product_id = item.id;
        //                     this.variants.push(this.selected_item);
        //                 }
        //             })
        //             this.itemTotal(this.variants);
        //         }else{
        //             error_message(response.data.message);
        //         }
        //     });
        // },
        itemTotal(items) {
            this.item_total = 0;
            this.net_value = 0;
            this.refund_total = 0;
            this.sub_total_2 = 0;
            this.sub_total = 0;
            this.total_amount = 0;
            this.coupon_applicable_amount = 0;
            this.collection_applicable_amount = 0;
            this.item_vat_total = 0;

            for (let i = 0; i < items.length; i++) {
                var variant = items[i];
                var price = (variant.min_qty <= variant.qty) ? variant.price : variant.mrp;
                let itemTotal = Number((variant.qty * Number(price)));
                let refund = Number((Number(variant.refund_price) * variant.qty).toFixed(this.decimal));
                let netTotal = 0;

                if (this.$refs.customerEditTab.customer_data.user_role == 1) {
                    netTotal = Number(((Number(itemTotal) * 100) / (100 + variant.vat)).toFixed(this.decimal));
                } else {
                    netTotal = Number(itemTotal.toFixed(this.decimal));
                    itemTotal = Number(netTotal + ((netTotal + refund) * variant.vat) / 100).toFixed(this.decimal);
                }

                this.item_total = Number((Number(this.item_total) + Number(itemTotal)).toFixed(this.decimal));
                this.net_value = Number((Number(this.net_value) + Number(netTotal)).toFixed(this.decimal));
                this.vat_total = Number(((Number(this.item_total) - Number(this.net_value))).toFixed(this.decimal));
                this.vat_percentage = this.vat_percentage + Number(variant.vat_percentage);
                this.refund_total = this.refund_total + Number(refund);
                this.sub_total_2 = Number(this.item_total);
                if(this.$refs.customerEditTab.customer_data.user_role == 5){
                    let itemVatTotal  =  Number(Number(netTotal) + Number(((netTotal) * variant.vat) / 100)).toFixed(this.decimal);
                    this.item_vat_total = Number((Number(this.item_vat_total) + Number(itemVatTotal)).toFixed(this.decimal));
                    
                }else{
                    this.item_vat_total = Number(this.item_total);
                }
                if (this.vaild_product.length > 0) {
                    var validProduct = this.vaild_product.filter(function (elem) {
                        if (elem == variant.product_id)
                        return elem;
                    });
                    
                    if (validProduct.length > 0) {
                        this.valid_item_total = Number(this.item_total.toFixed(this.decimal));
                        // if (this.$refs.customerEditTab.customer_data.user_role == 5) {
                        //     this.valid_item_total = Number(this.item_total.toFixed(this.decimal));
                        // }else{
                        //     this.valid_item_total = Number(Number(this.item_total)+Number(refund)).toFixed(this.decimal);
                        // }
                    }
                }

                if(variant.is_pickup_dis_applicable == 1 && this.type == 0){
                    if(this.$refs.customerEditTab.customer_data.user_role == 5){
                        this.coupon_applicable_amount = Number(Number(this.item_total)+Number(this.refund_total)).toFixed(this.decimal);
                    }else{
                        this.coupon_applicable_amount = Number(this.item_total.toFixed(this.decimal));
                    }
                }


                // if(this.$refs.customerTab.typeform.customer_id.user_role == 1){
                //   if (this.type_form.order_type == 1) {
                //     this.sub_total = this.sub_total + Number( Number(refund) + Number(this.sub_total_2) + Number(this.delivery_charge));
                //   } else {
                //     this.sub_total = this.sub_total + Number( Number(refund) + Number(this.sub_total_2) - Number(this.collection_discount_amount));
                //   }
                // }else{
                //   if (this.type_form.order_type == 1) {
                //     this.sub_total = this.sub_total + Number(Number(this.sub_total_2) + Number(this.delivery_charge));
                //   } else {
                //     this.sub_total = this.sub_total + Number(Number(this.sub_total_2) - Number(this.collection_discount_amount));
                //   }
                // }

                // this.total_amount = this.sub_total;
            }
            this.cartCal(0, this.vaild_coupon, this.coupon_applicable_amount);
        },
        couponCal() {
            if (this.vaild_coupon != "") {
                if (this.valid_item_total >= this.vaild_coupon.minimum_order_amount) {
                    if (this.vaild_coupon.is_flat_discount == 0) {
                        this.discount_amount = Number((Number(this.valid_item_total * Number(this.vaild_coupon.discount_percentage)) / 100).toFixed(this.decimal));
                        if (this.discount_amount > this.vaild_coupon.max_discount_amount) {
                        this.discount_amount = Number(this.vaild_coupon.max_discount_amount.toFixed(this.decimal));
                        }
                    } else {
                        this.discount_amount = Number(this.vaild_coupon.max_discount_amount.toFixed(this.decimal));
                    }
                }
            }
        },
        cartCal(credit, coupon, pickupApplicableAmount) {
            if (coupon != '') {
                this.couponCal();
            }else{
                this.discount_amount = 0;
                if(this.orderData.coupon != null){
                    this.discount_amount = this.orderData.coupon.discount_amount;
                }
                
            }
            var subAmount = 0;
            var orderTotal = 0;
            var subAmount1 = Number(this.item_total);
            var subAmount2 = subAmount1;
            var deliveryCharge = 0;
            var collectionDiscount = 0;
            pickupApplicableAmount = this.coupon_applicable_amount;

            
            if (this.$refs.customerEditTab.customer_data.user_role == 5) {
                subAmount1 = (Number(subAmount1) + Number(this.refund_total));
                subAmount2 = subAmount1;
            }
            this.sub_total_1 = subAmount1;
            
            if (this.discount_amount > 0) {
                subAmount2 = Number(subAmount1) - Number(this.discount_amount);
                pickupApplicableAmount = 0;
            }
            
            if (this.type_form.order_type == 1) { //deliveryAmount is amount
                deliveryCharge = this.delivery_charge;
            } else {
                pickupApplicableAmount = (pickupApplicableAmount == 0) ? subAmount1 : pickupApplicableAmount;
                if (this.discount_amount == 0) {
                collectionDiscount = Number(pickupApplicableAmount) * Number(this.collection_discount)/100;
                }
            }

            if (this.$refs.customerEditTab.customer_data.user_role == 5) {
                subAmount2 = subAmount2 + deliveryCharge - collectionDiscount;
            } else {
                subAmount2 = this.refund_total + subAmount2 + deliveryCharge - collectionDiscount;
            }
            if(this.orderData.credit_amount != 0){
                orderTotal = Number(subAmount2 - this.orderData.credit_amount);
            }else{
                orderTotal = subAmount2;
            }
            
            //debit from user credits ---
            if (credit > 0) {
                if (credit > subAmount2) {
                credit = subAmount2;
                }
                orderTotal = subAmount2 - credit;
            }
            this.collection_discount_amount = Number(collectionDiscount.toFixed(this.decimal));
            this.sub_total = subAmount2;
            this.total_amount = orderTotal;

        },
        // itemTotal(items){
        //     let total_credit = this.total_credit;
        //     this.item_total = 0;
        //     this.net_value = 0;
        //     this.refund_total = 0;
        //     this.sub_total_2 = 0;
        //     this.sub_total = 0;
        //     this.total_amount = 0;
        //     for (let i = 0; i < items.length; i++) {
        //         var variant = items[i];
        //         var price = (variant.min_qty <= variant.qty)?variant.price:variant.mrp;
        //         let itemTotal = (variant.qty * Number(price)).toFixed(this.decimal);
                
        //         let netTotal;
        //         if(this.cust_type == 1){
        //             netTotal = ((Number(itemTotal) * 100)/(100+variant.vat)).toFixed(this.decimal);
        //         }else{
        //             netTotal = Number(itemTotal);
        //             itemTotal = Number(netTotal+(netTotal*variant.vat)/100).toFixed(this.decimal);
        //         }
        //         let refund = (Number(variant.refund_price) * variant.qty).toFixed(this.decimal);

        //         this.item_total = this.item_total + Number(itemTotal);
        //         this.net_value = this.net_value + Number(netTotal);
        //         this.vat_total = (Number(this.item_total) - Number( this.net_value)).toFixed(this.decimal);
        //         this.vat_percentage =  this.vat_percentage + Number(variant.vat_percentage);
        //         this.refund_total = this.refund_total + Number(refund);
        //         this.sub_total_2 = this.item_total;

        //         if (this.type_form.order_type == 1) {
        //         this.sub_total = this.sub_total + Number( Number(refund) + Number(this.sub_total_2) + Number(this.delivery_charge));
        //         } else {
        //         this.sub_total = this.sub_total + Number( Number(refund) + Number(this.sub_total_2) - Number(this.collection_discount_amount));
        //         }

        //         if(total_credit >= this.sub_total){
        //             this.credit_amount = this.sub_total;
        //             this.total_amount = (this.sub_total) - Number(this.credit_amount);
        //         }else{
        //             this.credit_amount = this.total_credit;
        //             this.total_amount = (this.sub_total) - Number(this.credit_amount);
        //         }
        //         this.total_amount = this.sub_total;
                
        //     }
        // },
        custQty(sign,variant){
            console.log(variant);
            let item_price = variant.price;
            let is_new = variant.is_new;
            let i = 0;
            if(sign == '+'){
                let new_qty = variant.qty + 1;
                let available_qty;
                if(is_new == 1){
                    available_qty = new_qty;
                }else{
                    available_qty = (new_qty - variant.cart_quantity);
                }
                // console.log('variant.quantity',variant.quantity);
                // if (variant.quantity < available_qty) {
                //     $("span#plus").css("pointer-events", "none");
                //     error_message('Product limit over if.');
                //     return false;
                // }
                variant.qty++;
                this.changeCartQuantity(variant,variant.qty,'+');
                orderService.checkQuantity({id: variant.id}).then((response) => {
                    this.product_quanity = response.data.result.quantity;
                    // console.log('response.data',response.data);
                    // console.log('response.data',this.product_quanity);
                    if(this.product_quanity >= available_qty){

                        this.is_enable = 1;
    
                        this.itemTotal(this.variants);
                         var price = (variant.min_qty <= variant.qty)?variant.price:variant.mrp;
                        variant.item_price = variant.qty * price;

                    }else{
                        variant.qty--;
                        $("span#plus"+variant.id).css("pointer-events", "none");
                        error_message('Product limit over.');
                        //checkQty = 0;
                    }
                    
                    if(variant.is_new == 1){
                        $("span#minus_"+variant.id).css("pointer-events", "auto");
                    }
                    var old_qty = this.getCartQuantity(variant);

                    if(variant.is_new == 0 && old_qty.cart_quantity != variant.qty){
                        $("span#minus_"+variant.id).css("pointer-events", "auto");  
                    }
                });
            }else{
                var old_qty = this.getCartQuantity(variant);
                if(variant.is_new == 0 && old_qty.cart_quantity == variant.qty){
                    //console.log('variant.is_new',variant.is_new);
                    this.is_enable = 0;
                    this.disabled = true
                    $("span#minus_"+variant.id).css("pointer-events", "none");  
                }else{
                    variant.qty--;
                    this.changeCartQuantity(variant,variant.qty,'-');
                    if(variant.is_new == 0 && old_qty.cart_quantity != variant.qty){
                        $("span#minus_"+variant.id).css("pointer-events", "auto");  
                    }
                    if(variant.qty != 0){
                        if(this.variants.length > 0 && is_new == 0){
                            this.is_enable = 1;
                            var price = (variant.min_qty <= variant.qty)?variant.price:variant.mrp;
                            variant.item_price = variant.qty * price;
                        }
                        if(is_new == 1){
                            var price = (variant.min_qty <= variant.qty)?variant.price:variant.mrp;
                            variant.item_price = variant.qty * price;
                        }
                    }
                    
                    if(variant.qty == 0){
                        this.variants.splice(this.variants.indexOf(variant), 1);
                    }
                    this.itemTotal(this.variants);

                    $("span#plus"+variant.id).css("pointer-events", "auto");
                }
                
            }
        },
        changeCartQuantity(variant, qty, sign){
            let new_qty = 0;
            var old_qty = this.getCartQuantity(variant);
   
            if(old_qty != undefined){
                if(sign == '+'){
                    old_qty = old_qty.cart_quantity;
                    if(old_qty != qty){
                        new_qty = qty - old_qty;
                        var exists = this.newly_added_products.some(function(field) {
                            return field.product_id === variant.id;
                        });
                        if (!exists) {
                            this.is_enable = 1;
                            this.selected_item = {
                                ...variant,
                                product_id : variant.id,
                                qty: new_qty
                            };

                            this.newly_added_products.push(this.selected_item);
                        }

                        if (exists) { 
                            this.newly_added_products.forEach(item => {
                                if(item.product_id === variant.id){
                                    item.qty = new_qty
                                }
                            })
                        }
                    }
                }else{

                    new_qty = variant.qty - old_qty.cart_quantity;
                    this.newly_added_products.forEach(item => {
                        if(item.product_id === variant.id){
                            item.qty = new_qty
                        }
                    })

                    if(variant.qty == old_qty.cart_quantity){
                        this.is_enable = 0;
                        this.disabled = true
                        const objWithIdIndex = this.newly_added_products.findIndex((obj) => obj.product_id === variant.id);
                        if (objWithIdIndex > -1) {
                            this.newly_added_products.splice(objWithIdIndex, 1);
                        }
                    }
                }
            }
            
            //console.log('this.newly_added_products',this.newly_added_products);

        },
        getTimeSlot($event){
            this.selected_date = this.moment(this.type_form.schedule_date).format('YYYY-MM-DD');

            if(this.delivery_date != this.selected_date){
                this.disabled = false;
                this.is_enable = 1;
            }
            if(this.$refs.customerEditTab.customer_data.user_role == ''){
                if(this.$refs.customerEditTab.customer_data.user_role == 1){
                    this.cust_type = 2;
                }else{
                    this.cust_type = 1;
                }
            }else{
                if(this.$refs.customerEditTab.customer_data.user_role == '1'){
                    this.cust_type = 2;
                }else{
                    this.cust_type = 1;
                }
            }
           
            if(this.type_form.order_type == 1){
                orderService.getTimeSlotByDate({
                    delivery_date: this.selected_date,
                    latitude: this.$refs.customerEditTab.typeform.latitude,
                    longitude: this.$refs.customerEditTab.typeform.longitude,
                    vendor_id: "1",
                    order_type: 1,
                    customer_type: this.cust_type,
                    })
                    .then((response) => {
                        this.time_slot = [];
                        if(response.data.code == 200) {
                            this.time_slot = response.data.result.slots;
                        }
                });
            }
        },
        Onclick(event){
            if(this.type_form.order_type == 1){
                if(this.delivery_date == this.selected_date){
                    this.selected_timeslot = this.timeslot;
                    if(this.timeslot != event.target.value){
                        this.timeslot = event.target.value;
                        this.disabled = false;
                        this.is_enable = 1;
                    }
                }else if(this.delivery_date != this.selected_date){
                    this.timeslot = event.target.value;
                    this.disabled = false;
                    this.is_enable = 1;
                }else{
                    this.disabled = true;
                    this.is_enable = 0;
                }
                
            }else{
                if(this.delivery_date != this.selected_date){
                    this.disabled = false;
                    this.is_enable = 1;
                }else{
                    this.disabled = true;
                    this.is_enable = 0;
                }
            }
        },
        onRoleChange(){
            this.type = this.type_form.order_type;
            this.order_amount = Number(this.item_total);
            if(this.$refs.customerEditTab.customer_data.user_role == ''){
                if(this.$refs.customerEditTab.customer_data.user_role == 1){
                    this.cust_type = 2;
                }else{
                    this.cust_type = 1;
                    this.order_amount = Number(Number(this.item_total) + Number(this.refund_total));
                }
            }else{
                if(this.$refs.customerEditTab.customer_data.user_role == '1'){
                    this.cust_type = 2;
                }else{
                    this.cust_type = 1;
                    this.order_amount = Number(Number(this.item_total) + Number(this.refund_total));
                }
            }
            
            this.customer_first_name = this.$refs.customerEditTab.customer_data.user_name;
            this.customer_last_name = this.$refs.customerEditTab.customer_data.last_name;
            this.customer_phone = this.$refs.customerEditTab.customer_data.mobile_number;
            this.customer_email = this.$refs.customerEditTab.customer_data.email;

            this.customer_address = '';
            this.is_elevator = 0;
            this.parking_place = 1;
            if(this.$refs.customerEditTab.shipping_add_data != null){
                this.customer_address = this.$refs.customerEditTab.shipping_add_data.shipping_address;
                this.is_elevator = this.$refs.customerEditTab.shipping_add_data.is_elevator;
                this.parking_place = this.$refs.customerEditTab.shipping_add_data.parking_place;
            }

            if(this.$refs.customerEditTab.customer_data.is_billing_address == 0){
                this.customer_bill_address = ((this.$refs.customerEditTab.shipping_add_data != null))?this.$refs.customerEditTab.shipping_add_data.shipping_address:'';
            }

            orderService.getCharges({type: this.type, customer_type: this.cust_type, amount: this.order_amount}).then((response) => {
                if(this.order_data.coupon_id == '' || this.order_data.coupon_id == null){
                    this.subscription_discount_amount = Number(Number(Number(this.item_total)) * Number(this.subscription_discount)) / 100;
                    this.sub_total_2 = Number(this.item_total) - Number(this.subscription_discount_amount);
                }else{
                    this.getCoupon(this.item_total);
                }

                if(this.type == 1){
                    this.collection_discount_amount = 0;
                    if(response.data.result == ''){
                        this.delivery_charge = 0;
                    }else{
                        //uncomment if client ask for delivery charges
                        //this.delivery_charge = response.data.result.delivery_charges;

                        this.delivery_charge = 0;
                    }
                    if(this.order_amount == 0){
                        this.delivery_charge = 0;
                    }
                    // this.sub_total =  Number(Number(this.refund_total) + Number(this.sub_total_2) + Number(this.delivery_charge));
                }else{
                    this.delivery_charge = 0;
                    if(response.data.result == ''){
                        this.collection_discount_amount = 0;
                        this.collection_discount = 0;
                    }else{
                        this.collection_discount = response.data.result.delivery_charges;
                        this.collection_discount_amount = 0;
                    }
                    if(this.order_amount == 0){
                        this.collection_discount_amount = 0;
                        this.collection_discount = 0;
                    }
                    // this.sub_total =  Number(Number(this.refund_total) + Number(this.sub_total_2) - Number(this.collection_discount_amount));
                }
                // if(this.total_credit >= this.sub_total){
                //     this.credit_amount = this.sub_total;
                //     this.total_amount = Number(Number(this.sub_total) - Number(this.credit_amount));
                // }else{
                //     this.credit_amount = this.total_credit;
                //     this.total_amount = Number(Number(this.sub_total) - Number(this.credit_amount));
                // }
                this.itemTotal(this.variants)
                
            });
        },
        getCoupon(item_total){
            orderService.getCoupon({variants: JSON.stringify(this.variants), coupon_id : this.order_data.coupon_id }).then((response) => {
                if (response.data.code === 200) {
                    this.original_amount = response.data.result.orderTotal;
                    this.discount_amount = response.data.result.discountAmount;
                    this.cartCal(0, 0, 0)
                    // this.sub_total_2 = Number(Number(item_total) - Number(this.discount_amount))
                }
            });
        },
        getCartQuantity(variant){
            let old_qty = variant.qty;
            let product_data = [];
            this.sub_product.forEach(item => {
                this.variants.some(function(field) {
                        if(field.id === item.id){
                            product_data.push({'id': item.id, 'cart_quantity': item.cart_quantity});
                        }
                    });
                })
            old_qty = product_data.find(d => d.id == variant.id);
            return old_qty;
        },
        tabChanged(prevIndex,nextIndex){
            // console.log('prevIndex',prevIndex);
            // console.log('nextIndex',nextIndex);
            if(nextIndex == 1 && prevIndex != 2){
                if(!this.disabled){
                    this.setOrderItems();
                    // this.getOrderItem();
                    this.disabled = true;
                }
            }
            if(nextIndex == 2){
                this.onRoleChange();
                this.getTimeSlot();
                // console.log('this.is_enable',this.is_enable);
                if(this.is_enable == 0){
                    this.disabled = true;
                }else{
                    this.disabled = false;
                }
            }
            if(prevIndex == 2){
                if(!this.disabled){
                   this.setOrderItems()
                    // orderService.getOrderItem({order_id : this.$route.params.order_id}).then((response) => {
                    //     if (response.data.code === 200) {

                    //         // this.order_item = this.$refs.customerEditTab.customer_data;
                    //         this.order_item = response.data.result.order_item;
                    //         this.sub_product = response.data.result.sub_product;
                    //         this.type_form.order_type = response.data.result.order.delivery_type;
                    //         this.delivery_date = response.data.result.order.delivery_date;
                    //         this.sub_product.forEach(item => {
                    //             var exists = this.variants.some(function(field) {
                    //                 return field.id === item.id
                    //             });
                    //             if (!exists) {
                    //                 var vatCal = (Number(item.price * Number(item .vat) / 100)).toFixed(this.decimal);
                    //                 this.selected_item = {
                    //                     ...item,
                    //                     qty: item.item_quantity,
                    //                     item_price: item.item_quantity * item.price,
                    //                     // vat_price: item.item_quantity * vatCal,
                    //                     // vat_percentage: vatCal ,
                    //                     // refund_price: item.item_quantity * Number(item.refund_price),
                    //                     // refund_amount: Number(item.refund_price),
                    //                     selected_quantity:item.item_quantity,
                    //                     is_new: 0,
                    //                 };
                    //                 this.sub_product_id = item.id;
                    //                 this.variants.push(this.selected_item);
                    //                 // this.total_credit = this.order_data.credit_amount;
                    //                 // this.net_value = Number(this.net_value) + (Number(this.selected_item .item_price) - Number(this.selected_item .vat_percentage));
                    //                 // this.vat_total = Number(this.vat_total) + Number(this.selected_item .vat_price);
                    //                 // this.item_total = (Number(this.net_value) + Number(this.vat_total));
                    //                 // this.vat_percentage = this.vat_percentage + Number(this.selected_item .vat_percentage);
                    //                 // this.refund_total = this.refund_total + Number(this.selected_item .refund_price);

                    //                 // if(this.total_credit >= this.item_total){
                    //                 //     this.credit_amount = this.item_total;
                    //                 //     this.sub_total = (Number(this.refund_total) + Number(this.item_total) + Number(this.delivery_charge)) - Number(this.credit_amount);
                    //                 // }else{
                    //                 //     this.credit_amount = this.total_credit;
                    //                 //     this.sub_total = Number(this.credit_amount) - (Number(this.refund_total) + Number(this.item_total) + Number(this.delivery_charge));
                    //                 // }
                                    
                    //                 // if(this.order_data.subscription_discount == null){
                    //                 //     this.subscription_discount = 0; 
                    //                 // }else{
                    //                 //     this.subscription_discount = this.order_data.subscription_discount;
                    //                 // }
                    //                 // this.subscription_discount_amount = Number(Number(Number(this.sub_total)) * Number(this.subscription_discount)) / 100;
                    //                 // this.total_amount = Number(this.sub_total) - Number(this.subscription_discount_amount);
                    //             }
                    //         })
                    //         this.itemTotal(this.variants)
                    //     }else{
                    //         error_message(response.data.message);
                    //     }
                    // });
                }
            }
        },
        setOrderItems(){
            this.orderData = this.$refs.customerEditTab.orderData;
            this.order_item = this.$refs.customerEditTab.orderData.order_items;
            this.sub_product = this.$refs.customerEditTab.orderData.order_items;
            this.type_form.order_type = this.orderData.delivery_type;
            this.delivery_date = this.orderData.delivery_date;
            this.type_form.schedule_date = this.delivery_date;
            this.timeslot = this.orderData.delivery_from_time+' - '+this.orderData.delivery_to_time;
            this.selected_timeslot = this.orderData.delivery_from_time+' - '+this.orderData.delivery_to_time;
            this.credit_amount = this.$refs.customerEditTab.orderData.credit_amount;
            // console.log('this.date',this.type_form.schedule_date)
            // console.log('this.timeslot',this.timeslot)
            if(this.orderData.coupon != null){
                this.appliedCoupon = this.orderData.coupon.coupon_code
            }
            this.sub_product.forEach(item => {
                $("span#minus_"+item.id).css("cursor","default");
                var exists = this.variants.some(function(field) {
                    return field.id === item.id
                });
                
                if (!exists) {
                    var price = item.price;
                    var vatCal = (Number(price * Number(item.vat) / 100));
                    this.selected_item = {
                        ...item,
                        qty: item.cart_quantity,
                        item_price: item.amount,
                        // vat_price: item.item_quantity * (Number((Number(price * 100 ) / (100 + Number(item .vat))) * Number(item.vat)) / 100),
                        // vat_percentage: Number((Number(price * 100 ) / (100 + Number(item .vat))) * Number(item.vat)) / 100,
                        // refund_price: item.item_quantity * Number(item.refund_price),
                        // refund_amount: Number(item.refund_price),
                        // selected_quantity:item.cart_quantity,
                        is_new: 0,
                    };
                    this.sub_product_id = item.id;
                    this.variants.push(this.selected_item);
                }
            })
            this.itemTotal(this.variants);
        },
        applyPromoCode() {
            let new_items = [];
            this.variants.forEach((el) => {
                if(el.is_new == 1){
                    new_items.push(el);
                }
            });
            if(new_items == undefined || new_items.length == 0){
                new_items = this.variants;
            }

            if (this.promoApplied) {
                this.removePromocode()
                return false;
            }
            else if (!new_items || new_items.length == 0) {
                alert("Please add item");
                return false;
            } else {
                this.promo_loading = true;
                let itemTotal = 0;
                for (let i = 0; i < new_items.length; i++) {
                    itemTotal = itemTotal + new_items[i].item_price;
                }

                promoCodeService
                .applyPromoCode({
                    customer_type: this.cust_type,
                    sub_product: new_items,
                    coupon_code: this.promocode,
                    amount: Number(itemTotal),
                    type: this.type,
                    customer: JSON.stringify(this.$refs.customerEditTab.customer_data.user_id),
                })
                .then((response) => {
                    this.promo_loading = false;
                    if (response.data.code === 101) {
                    error_message(response.data.message);
                    }
                    if (response.data.code === 200) {
                        this.vaild_coupon = response.data.result;
                        this.valid_variants = this.variants;
                        this.coupon_id = response.data.result.coupon_id;
                        this.discount_percentage = response.data.result.discount_percentage;
                        this.minimum_order_amount = response.data.result.minimum_order_amount;
                        this.is_flat_discount = response.data.result.is_flat_discount;
                        this.max_discount_amount = response.data.result.max_discount_amount;
                        this.vaild_product = response.data.result.valid_products;
                        this.itemTotal(new_items)

                        success_message(response.data.message);
                        this.promoApplied = true;
                        return false;
                    }
                });
            }
        },
        removePromocode() {
            this.promoApplied = false;
            this.promocode = "";
            this.vaild_coupon = "";
            this.coupon_id = "";
            this.cartCal(0, this.vaild_coupon, 0)
        },
        updateOrder(){
            this.$v.type_form.$touch();
            if (this.$v.type_form.$invalid) {
                return;
            } else {
                
                if(!this.variants || this.variants.length == 0){
                    alert('Please add item');
                    return false;
                }else if(!this.selected_date || this.selected_date == ''){
                    alert('Please select schedule date and time slot');
                    return false;
                }else{
                    this.disabled = true;
                     var subProducts = this.variants.map((item) => {
                        return {
                        product_id: item.id,
                        quantity: item.qty
                        };
                    })

                    var orderProducts = this.variants.map((item) => {
                        if(item.is_new == 1){
                            return {
                                product_id: item.id,
                                quantity: item.qty
                            };
                        }
                    })

                    var orderNewProducts = this.newly_added_products.map((item) => {
                        return {
                            product_id: item.id,
                            quantity: item.qty
                        };
                    })

                    
                    
                    orderNewProducts = orderNewProducts.filter(e => e != null);
                    var new_product = orderProducts.filter(e => e != null);

                    // console.log('new_product',new_product);
                    // console.log('newly_added_products',orderNewProducts);
                    // console.log('arr1.concat(arr2); ',new_product.concat(orderNewProducts));
                    if(new_product.length > 0){
                        var updateProduct = new_product.concat(orderNewProducts);
                    }else{
                        var updateProduct = orderNewProducts;
                    }
                    
                    new_product = updateProduct.length > 0 ? JSON.stringify(updateProduct) : '';

                    // console.log('new_product22222',new_product);

                    const fd = new FormData();
                    fd.append('customer_type',this.cust_type);
                    fd.append('order_id',this.$route.params.order_id);
                    fd.append('net_value',(this.net_value).toFixed(this.decimal));
                    fd.append('vat_total',this.vat_total);
                    fd.append('item_total',this.item_total);
                    fd.append('refund_total',this.refund_total);
                    fd.append('sub_total',this.sub_total);
                    fd.append('delivery_fee',this.delivery_charge);
                    fd.append('delivery_type',this.type_form.order_type);
                    fd.append('delivery_date',this.selected_date);
                    fd.append('timeslot',this.timeslot);
                    // fd.append('is_elevator',this.is_elevator);
                    // fd.append('parking_place',this.parking_place);
                    // fd.append('parking_note',this.parking_note);
                    fd.append('original_amount',this.original_amount);
                    fd.append('discount_amount',this.discount_amount);
                    fd.append('credit_amount',parseFloat(this.credit_amount).toFixed(this.decimal));
                    fd.append('total',(this.total_amount).toFixed(this.decimal));
                    fd.append('subscription_discount_amount',parseFloat(this.subscription_discount_amount).toFixed(this.decimal));
                    fd.append('collection_discount_amount',parseFloat(this.collection_discount_amount).toFixed(this.decimal));
                    fd.append('sub_product',JSON.stringify(subProducts));
                    fd.append('order_product',new_product);
                    fd.append('item_vat_total',this.item_vat_total);
                    orderService.updateOrder(fd).then((response) => {
                        if (response.data.code === 200) {
                            success_message(response.data.message);
                            this.$router.push({ name: "orders-list" });
                        }else{
                            error_message(response.data.message);
                        }
                    });
                }
            }
        },
        disabledBeforeTodayAndAfterAWeek(date) {
            return date < new Date(new Date().setHours(0, 0, 0, 0));
        },
    },
};
</script>
<template>
    <Layout>
        <div class="row">
            <div class="col-12">
                <div
                class="page-title-box d-flex align-items-center justify-content-between icon-main-page"
                >
                <div class="page-title-left avatar-main-icon">
                    <div class="avatar-xs mr-3">
                        <span class="avatar-title rounded-circle bg-soft-primary text-primary font-size-18">
                            <i class="bx bx-briefcase"></i>
                        </span>
                    </div>
                    <div class="report-tag">
                        <h4 class="mb-0 font-size-18">{{ trans.trans('__JSON__.Update Order') }}</h4>
                        <p><router-link :to="{ name: 'orders-list'}">{{ trans.get('__JSON__.Orders') }}</router-link></p>
                    </div>
                </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <vue-form-wizard shape="tab" color="#556ee6" @on-change="tabChanged">
                                <tab-content icon="mdi mdi-account-circle" title="Customer Details" >
                                    <customer-edit-tab ref="customerEditTab"></customer-edit-tab>
                                </tab-content>

                                <tab-content icon="mdi mdi-food" :title="trans.get('__JSON__.Product')">
                                    <div class="col-12">
                                        <div class="row">
                                            <div class="col-md-6">
                                                <div class="drag-container">
                                                    <div class="row drag-list menu-left-main">
                                                        <div class="drag-column mulit-sel">
                                                            <span class="font-size-15 font-weight-medium">{{trans.get('__JSON__.Products')}}</span>
                                                            <div class="position-relative">
                                                                <multiselect
                                                                    v-model="type_form.selectedProduct"
                                                                    id="item_name"
                                                                    label="item_name"
                                                                    track-by="item_name"
                                                                    :placeholder="trans.get('__JSON__.Product Search')"
                                                                    open-direction="bottom"
                                                                    :options="products"
                                                                    :multiple="false"
                                                                    :searchable="true"
                                                                    :loading="isLoading"
                                                                    @search-change="asyncProduct"
                                                                    @select="productSelected"
                                                                >
                                                                    <template slot="tag" slot-scope="{ option, remove }">
                                                                        <span class="custom__tag">
                                                                            <span>{{ option.item_name }})</span>
                                                                            <span class="custom__remove" @click="remove(option)">❌</span>
                                                                        </span>
                                                                    </template>
                                                                    <template slot="clear" slot-scope="props">
                                                                        <div
                                                                            class="multiselect__clear"
                                                                            v-if="selectedProduct.length"
                                                                            @mousedown.prevent.stop="clearAll(props.search)"
                                                                        ></div>
                                                                    </template>
                                                                    <span slot="noResult">{{ trans.get('__JSON__.No Product Found') }}.</span>
                                                                </multiselect>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="drag-column">
                                                        <b-list-group>
                                                            <template v-if="items && items.length != 0 && !loading">
                                                                <template v-for="(item) in items || []" >
                                                                    <b-list-group-item 
                                                                    :key="item.id">

                                                                    <div class="d-flex justify-content-between">
                                                                        <div class="d-flex">
                                                                            <div>
                                                                                <div v-if="item.item_type == '0'" class="position-static veg"><span></span></div>
                                                                                <div v-if="item.item_type == '1'" class="position-static non-veg"><span></span></div>
                                                                            </div>
                                                                            <div>
                                                                                <div class="d-flex">
                                                                                    <span class="font-size-13 font-weight-medium pl-1" :title="item.sub_product_name">{{item.sub_product_name | truncate(35, '...')}} ({{item.material}})</span>
                                                                                </div>
                                                                                <span class="font-size-11 pl-1" :class="[(item.is_discount == 1 && item.is_b2b_price == 0) ? 'price-red' : '', (item.is_b2b_price == 1 && item.is_discount == 0) ? 'price-blue' : '', (item.is_discount == 0 && item.is_b2b_price == 0 ? 'text-secondary' : '')]">price : <span v-html="currency"></span> {{parseFloat(item.price).toFixed(decimal)}}</span>
                                                                                <span class="font-size-11 pl-1 text-secondary">mrp : <span v-html="currency"></span> {{parseFloat(item.mrp).toFixed(decimal)}}</span>
                                                                                <span class="font-size-11 pl-1 text-secondary"
                                                                                v-if="item.is_b2b_price == 1 && item.is_discount == 0">minimum quantity :
                                                                                {{
                                                                                    item.min_qty
                                                                                }}</span>
                                                                                <span class="font-size-11 pl-1 text-secondary">refund price : <span v-html="currency"></span> {{parseFloat(item.refund_price).toFixed(decimal)}}</span>
                                                                            </div>
                                                                        </div>
                                                                        <div>
                                                                            <div class="cst-swtch-set">
                                                                                <div class="list-available d-flex" v-if="item.quantity > 0">
                                                                                    <button class="btn btn-primary" id="add_variant" @click="addVariant(item)">{{trans.get('__JSON__.Add')}}</button>
                                                                                </div>
                                                                                <div class="list-available d-flex" v-else>
                                                                                    <span class="text-danger">{{trans.get('__JSON__.Sold out')}}</span>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    </b-list-group-item>
                                                                </template>
                                                            </template>
                                                            <div v-else-if="loading" class="text-center text-danger my-2 pt-5">
                                                                <b-spinner class="align-middle"></b-spinner>
                                                                <strong>{{trans.get('__JSON__.Loading...')}}</strong>
                                                            </div>
                                                            <b-list-group-item v-else key="abc" class="align-items-center d-flex justify-content-between">
                                                                {{trans.get('__JSON__.No sub product found')}}
                                                            </b-list-group-item>
                                                        </b-list-group>
                                                        <div class="row mt-2"  v-if="!loading">
                                                            <div class="col">
                                                            <div class="dataTables_paginate paging_simple_numbers float-right" v-if="items && items.data">
                                                                <ul class="pagination pagination-rounded mb-0">
                                                                    <pagination :data="items" :limit="limit" @pagination-change-page="listitembyid"></pagination>
                                                                </ul>
                                                            </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-5">
                                                <div class="drag-column">
                                                    <b-list-group>
                                                        <template v-for="(variant) in variants || []">
                                                            <b-list-group-item  :key="variant.id">
                                                                <p class="font-size-13 font-weight-medium pl-1" style="border-bottom:1px solid;" :title="variant.item_name">{{variant.item_name | truncate(35, '...')}}</p> 
                                                                <div class="row justify-content-between">    
                                                                    <div class="col-md-5">
                                                                        <div class="d-flex">
                                                                            <span class="font-size-13 font-weight-medium pl-1" :title="variant.sub_product_name">{{variant.sub_product_name | truncate(35, '...')}} ({{variant.material}})</span>
                                                                        </div>
                                                                        <span class="font-size-11 pl-1">price : <span v-html="currency"></span> {{parseFloat(variant.price).toFixed(decimal)}}</span>
                                                                    </div>
                                                                    <div class="col-md-3">
                                                                        <div class="list-available d-flex item-new-add">
                                                                            <span class="minus d-flex justify-content-center align-items-center" :id="'minus_'+variant.id" @click="custQty('-',variant)">-</span>
                                                                            <span class="qty-item">{{variant.qty}}</span>
                                                                            <span class="d-flex justify-content-center align-items-center" :id="'plus_'+variant.id" @click="custQty('+',variant)">+</span>
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-md-4 text-right">
                                                                        <span class="font-size-11 pl-1 text-secondary">price : <span v-html="currency"></span> {{parseFloat(variant.item_price).toFixed(decimal)}}</span>
                                                                        
                                                                    </div>
                                                                </div>
                                                                
                                                            </b-list-group-item>
                                                        </template>
                                                        <div>
                                                            <span class="font-size-11 pl-1 text-secondary">Net Value : <span v-html="currency"></span> {{parseFloat(net_value).toFixed(decimal)}}</span>
                                                            <span class="font-size-11 pl-1 text-secondary">Vat Total : <span v-html="currency"></span> {{parseFloat(vat_total).toFixed(decimal)}}</span>
                                                            <span class="font-size-11 pl-1 text-secondary">Total : <span v-html="currency"></span> {{parseFloat(item_total).toFixed(decimal)}}</span>
                                                        </div>
                                                    </b-list-group>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- end col -->
                                    </div>
                                </tab-content>

                                <tab-content icon="mdi mdi-checkbox-marked-circle-outline" :title="trans.get('__JSON__.Order Summary')">
                                    <div class="row">
                                        <div class="col-sm-4">
                                            <div>
                                                <div class="mt-2">
                                                    <label for="future_delivery_date">{{trans.get('__JSON__.Order Type')}}</label>
                                                    <select
                                                        name="order_type"
                                                        class="custom-select"
                                                        id="order_type"
                                                        v-model="type_form.order_type"
                                                        @change="onTypeChange()"
                                                        :disabled="true"
                                                    >
                                                        <option value="">{{ trans.get('__JSON__.Select Order Type') }}</option>
                                                        <option value="1" selected>Delivery</option>
                                                        <option value="0">Pickup</option>
                                                    </select>
                                                </div>
                                                <div class="mt-2">
                                                    <label for="future_delivery_date">{{trans.get('__JSON__.Schedule Time')}}</label>
                                                    <date-picker
                                                        :clearable="false"
                                                        v-model="$v.type_form.schedule_date.$model"
                                                        format="YYYY-MM-DD"
                                                        type="date"
                                                        class="date-time"                          
                                                        :placeholder="trans.get('__JSON__.Select Schedule Time')"
                                                        value-type="format"
                                                        :disabled-date="disabledBeforeTodayAndAfterAWeek"
                                                        :class="{ 'is-invalid':$v.type_form.schedule_date.$error }"
                                                        :disabled="true"
                                                    ></date-picker>
                                                    <div v-if="$v.type_form.schedule_date.$error" class="invalid-feedback">
                                                        <span v-if="!$v.type_form.schedule_date.required">{{ trans.get('__JSON__.Please select business type') }}</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="InputGroup"> 
                                                <div v-if="time_slot.length > 0 && type == 1">
                                                    <div v-for="(slot) in time_slot" :key="slot.id">
                                                        <div v-if="slot.is_available == 1 || (order_data.delivery_from_time == slot.from_time && order_data.delivery_to_time == slot.to_time)">
                                                            <input class="form-check-input" 
                                                            type="radio" 
                                                            name="time" 
                                                            id="time"  
                                                            @change="Onclick($event)" 
                                                            v-bind:value="slot.from_time +'-'+ slot.to_time" :checked="orderData.delivery_from_time == slot.from_time && orderData.delivery_to_time == slot.to_time" 
                                                            disabled/>

                                                            <label class="form-check-label" for="time">{{ slot.from_time}} - {{ slot.to_time}}</label>
                                                        </div>
                                                        <div v-else>
                                                            <label class="form-check-label" for="time">{{ slot.from_time}} - {{ slot.to_time}} (Not Available)</label>
                                                        </div>
                                                        
                                                    </div>
                                                </div>
                                                <div v-else>
                                                    <span v-if="type == 1">{{ trans.get('__JSON__.Timeslot not found') }}.</span>
                                                </div>
                                            </div>
                                        </div>
                                        
                                        <div class="col-sm-4">
                                            <b-list-group>
                                                <b-list-group-item>
                                                    <span class="font-size-14 font-weight-bold">{{trans.get('__JSON__.Customer Name')}}: </span> {{customer_first_name}} {{customer_last_name}}
                                                </b-list-group-item>
                                                <b-list-group-item>
                                                    <span class="font-size-14 font-weight-bold">{{trans.get('__JSON__.Email')}}: </span> {{customer_email}}
                                                </b-list-group-item>
                                                <b-list-group-item>
                                                    <span class="font-size-14 font-weight-bold">{{trans.get('__JSON__.Phone')}}: </span> {{customer_phone}}
                                                </b-list-group-item>
                                                <b-list-group-item>
                                                    <span class="font-size-14 font-weight-bold">{{trans.get('__JSON__.Address')}}: </span> {{customer_address || ''}}
                                                </b-list-group-item>
                                            </b-list-group>
                                        </div>

                                        <div class="col-sm-4">
                                            <div>
                                                <label for="Promo Code" v-if="this.orderData.coupon != null">{{
                                                    trans.get("__JSON__.Promo Code")
                                                }}</label>
                                                <!-- <b-input-group prepend="Enter Code" v-if="this.orderData.coupon == null">
                                                    <b-form-input ref="promocode" name="promocode" v-model="promocode" :disabled="promoApplied"
                                                        @keyup.enter="applyPromoCode"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button :variant="
                                                        promoApplied ? 'outline-danger' : 'outline-success'
                                                        " @click="applyPromoCode" :disabled="promo_loading">{{ promoApplied ? "Remove" : "Apply" }}
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group> -->

                                                <b-input-group prepend="Enter Code" v-if="this.orderData.coupon != null">
                                                    <b-form-input ref="appliedCoupon" name="appliedCoupon" v-model="appliedCoupon" :disabled="true"></b-form-input>
                                                </b-input-group>
                                            </div>
                                            <table style="width:100%;">
                                                <tr>
                                                    <td>Net Value :</td>
                                                    <td class="float-right">{{ parseFloat(net_value).toFixed(decimal) }}<span v-html="currency"></span></td>
                                                </tr>
                                                <tr style="border-bottom:1px solid #eee;">
                                                    <td>Tax :</td>
                                                    <td class="float-right">{{ parseFloat(vat_total).toFixed(decimal) }}<span v-html="currency"></span></td>
                                                </tr>
                                                <tr v-if="cust_type == 1">
                                                    <td>Refund Total :</td>
                                                    <td class="float-right">{{ parseFloat(refund_total).toFixed(decimal) }}<span v-html="currency"></span></td>
                                                </tr>
                                                <tr style="border-bottom:1px solid #eee;">
                                                    <td>Sub Total 1 :</td>
                                                    <td class="float-right">{{ parseFloat(sub_total_1).toFixed(decimal) }}<span v-html="currency"></span></td>
                                                </tr>
                                                <tr v-if="type_form.order_type == '0'">
                                                    <td>Collection Discount ({{collection_discount}}%):</td>
                                                    <td class="float-right">  <span v-if="collection_discount_amount > 0">-</span> {{ parseFloat(collection_discount_amount).toFixed(decimal) }}<span v-html="currency"></span></td>
                                                </tr>
                                                <tr style="border-bottom:1px solid #eee;">
                                                    <td>Coupon Discount :</td>
                                                    <td class="float-right"> <span v-if="discount_amount > 0">-</span> {{ parseFloat(discount_amount).toFixed(decimal) }}<span v-html="currency"></span></td>
                                                </tr>
                                                <tr v-if="cust_type == 2">
                                                    <td>Refund Total :</td>
                                                    <td class="float-right">{{ parseFloat(refund_total).toFixed(decimal) }}<span v-html="currency"></span></td>
                                                </tr>
                                                <tr>
                                                    <td>Delivery Fees :</td>
                                                    <td class="float-right">{{ parseFloat(delivery_charge).toFixed(decimal) }}<span v-html="currency"></span></td>
                                                </tr>
                                                <tr style="border-bottom:1px solid #eee;border-top:1px solid #eee;">
                                                    <td>Credit:</td>
                                                    <td class="float-right"><span v-if="credit_amount > 0">-</span> {{ parseFloat(credit_amount).toFixed(decimal) }}<span v-html="currency"></span></td>
                                                </tr>
                                                <tr>
                                                    <td><strong>Total :</strong></td>
                                                    <td class="float-right"><strong>{{ parseFloat(total_amount).toFixed(decimal) }}</strong><span v-html="currency"></span></td>
                                                </tr>
                                            </table>
                                        </div>

                                        <!-- end col -->
                                    </div>
                                </tab-content>

                                <div slot="finish"></div>
                                <button slot="finish" class="btn btn-primary mr-1 mt-3" :disabled="disabled" id="place_order" @click="updateOrder">{{ trans.get('__JSON__.Update Order') }}</button>

                            </vue-form-wizard>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>